<template>
    <div :class="cardClass">
        <div class="card__connections-count">
            <span v-if="showPending" class="card__connection-pending">
                {{ $t('elements.referrals.card.pending') }}
            </span>
            <p v-else-if="ancillary.connectionCount">
                <b>{{ ancillary.connectionCount }}</b>
                <span>{{ $t('elements.referrals.card.connections') }}</span>
            </p>
        </div>
        <div v-if="showNetworkInclusionStatus" class="card__network-status">
            <network-inlusion-status
                :targetId="targetId"
                :targetType="targetType"
                :isInMyNetwork="isInMyNetwork"
                @emitEvent="emitEvent($event)"
            ></network-inlusion-status>
        </div>
        <div class="card__checkbox-input">
            <checkbox-input :value="checked(ancillary.id)" @change="selectionChanged(ancillary.id)"></checkbox-input>
        </div>
        <practice-card :practice="ancillary" :showInvitedDate="showInvitedDate"></practice-card>

        <template v-if="isStandalone">
            <div class="card__cta">
                <card-availability
                    v-if="showCardAvailability"
                    :physician="{}"
                    :ancillary="ancillary"
                    :practiceId="ancillary.id"
                    :showDirectReferralAsInnerModal="showCardAvailabilityAsInnerModal"
                    :locations="ancillary.locations || ancillary.practiceLocations"
                ></card-availability>
            </div>
        </template>
    </div>
</template>

<script>
    import PracticeCard from 'components/page-elements/practice/PracticeCard'
    import CardAvailability from 'components/page-elements/referrals-new-card/CardAvailability'
    import NetworkInlusionStatus from 'components/page-elements/network/NetworkInlusionStatus'
    import UserMembershipStatusEnum from '../../../enums/UserMembershipStatusEnum'
    import UserTypeEnum from '@/enums/UserTypeEnum'
    import CheckboxInput from 'components/form-inputs/CheckboxInput'

    export default {
        components: {
            PracticeCard,
            CardAvailability,
            NetworkInlusionStatus,
            CheckboxInput,
        },

        props: {
            ancillary: { type: Object, default: undefined },
            isStandalone: { type: Boolean, default: true },
            isFixedHeight: { type: Boolean, default: true },
            showCardAvailability: { type: Boolean, default: true },
            showNetworkInclusionStatus: { type: Boolean, default: false },
            showInvitedDate: { type: Boolean, default: false },
            showCardAvailabilityAsInnerModal: { type: Boolean, default: false },
            checkedValues: { type: Array, default: () => [] },
        },

        computed: {
            cardClass() {
                return {
                    card: true,
                    'card__fixed-hight': this.isFixedHeight,
                    'card--is-standalone': this.isStandalone,
                }
            },

            targetType() {
                return UserTypeEnum.PRACTICE
            },

            targetId() {
                return this.ancillary?.id
            },

            isInMyNetwork() {
                return this.ancillary.isInMyNetwork !== undefined ? this.ancillary.isInMyNetwork : true
            },

            isPendingApproval() {
                return (
                    this.showMasterUserAuthorities &&
                    this.$auth.getUser().isMasterUser &&
                    this.ancillary.practiceMembershipStatus === UserMembershipStatusEnum.PENDING
                )
            },

            userHasPendingInvitation() {
                return this.ancillary.target && !this.ancillary.target.dateJoined
            },

            showPending() {
                return this.isPendingApproval || this.userHasPendingInvitation
            },
        },

        methods: {
            checked(id) {
                return this.checkedValues.includes(id)
            },

            selectionChanged(id) {
                this.emitEvent({ name: 'selection-changed', payload: id })
            },
        },
    }
</script>
